// extracted by mini-css-extract-plugin
export default {"tabLabel":"GuideNavigationTabs_tabLabel__o02Hr"};